var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8C15.4183 8 19 6.65685 19 5C19 3.34315 15.4183 2 11 2C6.58172 2 3 3.34315 3 5C3 6.65685 6.58172 8 11 8Z",
    stroke: "#E6695E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.8418C6.60158 11.0226 7.27434 11.1716 8 11.2817",
    stroke: "#E6695E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 13.5299 6.05369 14.7923 10 14.9768",
    stroke: "#E6695E",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.8418C6.60158 18.0226 7.27434 18.1716 8 18.2817",
    stroke: "#E6695E",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C6.58172 22 3 20.6569 3 19V5M19 5V11",
    stroke: "#E6695E",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.7143V22M17 20.7143C15.8432 20.7143 14.8241 20.1461 14.2263 19.2833M17 20.7143C18.1568 20.7143 19.1759 20.1461 19.7737 19.2833M14.2263 19.2833L13.0004 20.0714M14.2263 19.2833C13.8728 18.773 13.6667 18.1597 13.6667 17.5C13.6667 16.8403 13.8727 16.2271 14.2262 15.7169M19.7737 19.2833L20.9996 20.0714M19.7737 19.2833C20.1272 18.773 20.3333 18.1597 20.3333 17.5C20.3333 16.8403 20.1273 16.2271 19.7738 15.7169M17 14.2857C18.1569 14.2857 19.1761 14.854 19.7738 15.7169M17 14.2857C15.8431 14.2857 14.8239 14.854 14.2262 15.7169M17 14.2857V13M19.7738 15.7169L21 14.9286M14.2262 15.7169L13 14.9286",
    stroke: "#E6695E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/Database.daffa369525c5ab0e87c47c39237fe95.svg";
export { ForwardRef as ReactComponent };